module.exports = __webpack_public_path__ + "static/banner2-f8cf496d8d1c07926c90481704fb9643.png";